/* eslint-disable */
// import { validation } from './commonValidation';
import toast from './toast';

const changePassword = () => {
  const form = document.querySelector('.js-pwd-change-form');
  const pwdInputOld = document.querySelector('.js-change-pwd-old');
  const pwdInputNew = document.querySelector('.js-change-pwd-new');
  const pwdInputRetype = document.querySelector('.js-change-pwd-retype');
  const submitBtn = document.querySelector('.js-change-pwd-submit');

  const sendAjax = e => {
    e.preventDefault();

    let ajaxData = {
      action: 'ks_pwd_change',
      ks_pwd_old: pwdInputOld.value,
      ks_pwd_new: pwdInputNew.value,
      ks_pwd_retype: pwdInputRetype.value,
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        const response = JSON.parse(this.response);
        if (response.error) {
          let error_notify_container = document.querySelector(
            '.js-pwd-change-form-error-container',
          );
          let error_notify = document.querySelector(
            '.js-pwd-change-form-error-text',
          );
          error_notify.innerHTML = response.error;
          error_notify_container.classList.remove('u-hidden');
        } else {
          const toastWrapper = document.createElement('div');
          const body = document.querySelector('body');

          toastWrapper.innerHTML = response.message;
          body.append(toastWrapper);
          if (response.success && response.redirect) {
            setTimeout(() => {
              window.location.href = response.redirect;
            }, 3000);
          }
          toast();
          body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
        }
      }
    };
    request.onerror = function () { };
    request.send(ajaxParameters);
  };

  function hasLowerCase(str) {
    return str.toUpperCase() != str;
  }
  function hasUpperCase(str) {
    return str.toLowerCase() != str;
  }
  function checkPassword(e) {
    const password = document.querySelector('.js-validated-password-input');
    const retype = document.querySelector('.js-change-pwd-retype');

    if (password.value === retype.value) {
      document
        .querySelector('.js-pwd-retype')
        .setAttribute('data-valid', '1');
    } else {
      document
        .querySelector('.js-pwd-retype')
        .setAttribute('data-valid', '0');
    }

    if (password.value.length >= 8) {
      document.querySelector('.js-pwd-length').setAttribute('data-valid', '1');
    } else {
      document.querySelector('.js-pwd-length').setAttribute('data-valid', '0');
    }
    if (hasLowerCase(password.value)) {
      document
        .querySelector('.js-pwd-small-letter')
        .setAttribute('data-valid', '1');
    } else {
      document
        .querySelector('.js-pwd-small-letter')
        .setAttribute('data-valid', '0');
    }
    if (hasUpperCase(password.value)) {
      document
        .querySelector('.js-pwd-big-letter')
        .setAttribute('data-valid', '1');
    } else {
      document
        .querySelector('.js-pwd-big-letter')
        .setAttribute('data-valid', '0');
    }
    let format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (format.test(password.value)) {
      document
        .querySelector('.js-pwd-special-letter')
        .setAttribute('data-valid', '1');
    } else {
      document
        .querySelector('.js-pwd-special-letter')
        .setAttribute('data-valid', '0');
    }
  }

  const pwdChangeValidation = e => {
    e.preventDefault();
    sendAjax(e);
  };

  if (form) {
    form.addEventListener('submit', pwdChangeValidation);
    const password = document.querySelector('.js-validated-password-input');
    const retype = document.querySelector('.js-change-pwd-retype');
    password.addEventListener('keyup', checkPassword);
    retype.addEventListener('keyup', checkPassword);
  }
};

export default changePassword;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/changePassword.js